import ShiftDto from '@/models/Shifts/ShiftDto';
import SkillDto from '@/models/Skills/SkillDto';
import PositionDto from '@/models/Positions/PositionDto';
import UniformDto from '@/models/Uniforms/UniformDto';
import DeskDto from '@/models/Desks/DeskDto';
import QualificationDto from '@/models/Qualifications/QualificationDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import AgencyUserDto from '../AgencyUsers/AgencyUserDto';
import ContactDto from '../Contacts/ContactDto';
import BookingRoleStatus from './BookingRoleStatus';

export default class BookingRoleDto extends BaseAgencyScopeEntityDto {
    status: BookingRoleStatus;
    bookingId = '';
    ownerId = '';
    owner: AgencyUserDto = new AgencyUserDto();
    contactId = '';
    contact: ContactDto = new ContactDto();
    quantity = 1;
    positionId = '';
    position: PositionDto = new PositionDto();
    positionDescription = '';
    chargeRate = 0;
    deskId = '';
    desk: DeskDto = new DeskDto();
    uniformId = '';
    uniform: UniformDto = new UniformDto();
    uniformDescription = '';
    skills: SkillDto[] = [];
    qualifications: QualificationDto[] = [];
    shifts: ShiftDto[] = [];
}